import React, { useState } from "react";
import axios from "axios";
import { config } from "../../../../config";
import ReactQuill from "react-quill"; // Step 2: Import ReactQuill
import "react-quill/dist/quill.snow.css"; // Step 2: Import Quill styles

const apiUrl = config.apiUrl;

const CreateOffer = ({ onOfferCreated }) => {
  const [formData, setFormData] = useState({
    offerHeadline: "",
    offerPrice: "",
    offerSubHeadline: "",
    paymentText: "", // Will store the HTML output from ReactQuill
    paymentNumber: "",
    redirect:"",
    buttonText: "",
    pixelId: "",
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Handle change specifically for ReactQuill editor (for paymentText)
  const handleQuillChange = (value) => {
    setFormData((prev) => ({ ...prev, paymentText: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await axios.post(`${apiUrl}/offers`, formData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      alert("Offer Created Successfully!");
      onOfferCreated();
    } catch (err) {
      setError("An error occurred while creating the offer.");
    }
  };

  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Create Offer</h2>
      {error && <p className="text-red-500">{error}</p>}
      <form onSubmit={handleSubmit}>
        
        <div className="mb-4">
          <label className="block text-gray-700">Offer Headline</label>
          <input
            type="text"
            name="offerHeadline"
            value={formData.offerHeadline}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Offer Price</label>
          <input
            type="text"
            name="offerPrice"
            value={formData.offerPrice}
            onChange={handleChange}
            className="border w-full p-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Offer Sub Headline</label>
          <input
            type="text"
            name="offerSubHeadline"
            value={formData.offerSubHeadline}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Payment Text</label>
          {/* Step 3: Replace input with ReactQuill */}
          <ReactQuill
            value={formData.paymentText}
            onChange={handleQuillChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Payment Number</label>
          <input
            type="text"
            name="paymentNumber"
            value={formData.paymentNumber}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Redirect Link</label>
          <input
            type="text"
            name="redirect"
            value={formData.redirect}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-700">Button Text</label>
          <input
            type="text"
            name="buttonText"
            value={formData.buttonText}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Facebook Pixel Id</label>
          <input
            name="pixelId"
            value={formData.pixelId}
            onChange={handleChange}
            className="border w-full p-2"
          />
        </div>

        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Create Offer
        </button>
      </form>
    </div>
  );
};

export default CreateOffer;
